import "./mentors.css";

const Mentors = ({ mentors }: { mentors: any[] }) => {
  return (
    <div>
      <div className="container" style={{ marginTop: "104px" }}>
        <h3 className="text-[#222222] font-bold text-[24px] text-center mb-[48px]">
          Our Global Mentors
        </h3>

        <div className="w-full grid grid-cols-3 gap-4 sm:grid-cols-2 md:grid-cols-2 gap-y-[20px] sm:gap-x-5 sm:w-[140vw]">
          {mentors.map((mentor, index) => (
            <div
              className=" border border-[#E5E5E5] px-[24px] pt-[24px] rounded-2xl"
              key={index}
            >
              <img src={mentor.icon} alt="" className="object-cover" />
              <div className="mt-[0.5em] px-2">
                <div className="flex justify-between">
                  <p className="mentor_p">
                    {mentor.name}
                    <span className="mentor_span">{mentor.stack}</span>
                  </p>
                  <span className="mentor_span">
                    Experience
                    <p className="mentor_p">{mentor.experience} Years</p>
                  </span>
                </div>
                <div className="flex justify-between">
                  <span className="mentor_span">
                    Sessions<p className="mentor_p">{mentor.sessions}</p>
                  </span>
                  <div className="text-[#636363] text-[14px] flex flex-col items-center">
                    Countries Worked In
                    <div className="flex gap-2">
                      {mentor.countries.map((country: any, index: any) => (
                        <img src={country} alt="" key={index} />
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Mentors;
